import request from 'superagent'
import types from '../types'
import Resource from '../../types/Resource'

import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
let api_url = `${protocol}//${hostname}:${api_port}/api`

if (api_port === '') {
    api_url = `${protocol}//${hostname}/api`
}

export const getResources = (token: string) => {
    return (dispatch: any) => {
        dispatch(getResourcesRequested())
        request
          .get(`${api_url}/resources`)
          .set('Accept', 'application/json')
          .set('access-token',token)
          .then((response) => {
            dispatch(getResourcesFulfilled(response.body))
          })
          .catch((error) => {
            dispatch(getResourcesRejected(error))
          })
    }
}

const getResourcesRequested = () => ({
    type: types.GET_RESOURCES_REQUESTED,
    payload: null
})

const getResourcesFulfilled = (data: Array<Resource>) => ({
    type: types.GET_RESOURCES_FULFILLED,
    payload: data
})

const getResourcesRejected = (error: any) => ({
    type: types.GET_RESOURCES_REJECTED,
    payload: error
})